import Icon from '../components/Icon.vue'

Icon.register({
  teeth: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 0c53 0 96 43 96 96v320c0 53-43 96-96 96h-448c-53 0-96-43-96-96v-320c0-53 43-96 96-96h448zM160 368v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v64c0 26.5 21.5 48 48 48s48-21.5 48-48zM160 240v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16zM304 360v-56c0-8.8-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16v56c0 30.9 25.1 56 56 56s56-25.1 56-56zM304 240v-88c0-30.9-25.1-56-56-56s-56 25.1-56 56v88c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16zM448 360v-56c0-8.8-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16v56c0 30.9 25.1 56 56 56s56-25.1 56-56zM448 240v-88c0-30.9-25.1-56-56-56s-56 25.1-56 56v88c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16zM576 368v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v64c0 26.5 21.5 48 48 48s48-21.5 48-48zM576 240v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/teeth.js
// module id = 1989
// module chunks = 0